<template>
    <div>
        ล๊อตสินค้า
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>